export const adaptPrecioDetalleMasivo = (precioData) => {
    return {
        idEvaluacion: precioData?.idEvaluacion,
        delegacion: precioData?.delegacion,
        cod_Sap: precioData?.cod_Sap,
        cliente: precioData?.cliente,
        paciente: precioData?.paciente,
        precioDiario: precioData?.precioDiario,
        precioAModificar: precioData?.precioAModificar,
        viable: precioData?.viable,
        precioSAP: precioData?.precioSAP,
        tipoPrecio: precioData?.tipoPrecio,
        vigencia: precioData?.vigencia,
        precioControl: precioData?.precioControl,
        periodo: precioData?.periodo,
        gerenteO: precioData?.gerenteO,
        gerenteG: precioData?.gerenteG,
        existe: precioData?.existe
    }
}

export const adaptPrecioDetalleMasivoArray = (
    precios
) => {
    return structuredClone(precios?.detallePrecioMasivo.valorEsperado)
        ?.map(precio => adaptPrecioDetalleMasivo(precio));
}